<div class="md:grid md:grid-cols-4 gap-6 mb-12 text-base font-medium sm:flex sm:flex-col">
    <ng-container *ngFor="let item of data; let index=index">
        <div class="text-white">
            <!--Titolo-->
            <span class="font-semibold">{{item.title}}</span>

            <div class="border-b my-5"></div>

            <ng-container *ngIf="index==2">
                <demo-social-links></demo-social-links>
            </ng-container>

            <span class="underline" [innerHTML]="sanitize(item.meta)"></span>



        </div>
    </ng-container>
</div>
